import React, { useEffect, useState } from "react";
import { TimelineEvent } from "../Timeline/Types";
import { FabContainer, NotificationFab } from "./NewEventsFab.styles";
import { ArrowUpIcon } from "@icons/SolidArrowUpIcon";
import { RefreshContentTypography } from "../../RefreshContentButton/RefreshContentButton.styles";

export function NewEventsButton({
    active,
    timeline,
    onClick,
}: {
    active: boolean;
    onClick: () => void;
    timeline: TimelineEvent[] | undefined;
}) {
    const [events, setEvents] = useState<TimelineEvent[]>([]);
    const [newEvents, setNewEvents] = useState(0);

    useEffect(() => {
        if (!timeline) {
            return;
        }
        if (events.length && active) {
            setNewEvents(timeline.length - events.length);
        }
        if (!active) {
            setEvents(timeline);
        }
    }, [active, timeline]);

    return newEvents !== 0 ? (
        <FabContainer>
            <NotificationFab
                withOrangeColorStyles={true}
                variant={"extended"}
                onClick={() => {
                    setNewEvents(0);
                    onClick();
                }}
            >
                <ArrowUpIcon width={"20px"} height={"20px"} />
                <RefreshContentTypography>
                    {newEvents} neue{newEvents === 1 ? "s" : ""} Event
                    {newEvents === 1 ? "" : "s"}
                </RefreshContentTypography>
            </NotificationFab>
        </FabContainer>
    ) : (
        <></>
    );
}
